import getExtensionConfiguration from './extension-configuration';

const getMainSource = (rootState, slug) => {
  const configuration = getExtensionConfiguration(rootState, slug);

  return configuration && configuration.mainSource;
};

export default getMainSource;
